import { UATConstants } from 'src/Common/Models/UATConstants';

export const DIRECT_LANDING_CLOSED_EVENT = 'direct-landing-closed';

export const directLandingUrlParams = {
  tenantId: 'tenantId',
  mode: 'mode',
  assignedTo: 'assignedTo',
  team: 'team',
  refId: 'refId',
  business: 'business',
  source: 'source',

  desc: 'desc',
  account: 'account',
  area: 'area',
  eou: 'eou',
  requesttype: 'requesttype',
  role: 'role',
  areaofinterest: 'areaofinterest',
  region: 'region',
  headerless: 'headerless',
};

export const getDirectLandingUrlParams = (URLParam: string): string => {
  const params = new URL(window.location.href).searchParams;
  return params.get(URLParam)?.toString() || '';
};

export const isDirectLandCreate = (): boolean => {
  const tenantId: string = getDirectLandingUrlParams(directLandingUrlParams.tenantId);
  const mode: string = getDirectLandingUrlParams(directLandingUrlParams.mode);
  return tenantId && tenantId != '' && mode && mode === 'create' ? true : false;
};

export const isDirectLandGPSPartnerInvestment = (): boolean => {
  if (isDirectLandCreate()) {
    const tenantId: string = getDirectLandingUrlParams(directLandingUrlParams.tenantId);
    return tenantId === UATConstants.AllTenant.PartnerInvestments.ID;
  }

  return false;
};

export const isDirectLandRedButton = (): boolean => {
  if (isDirectLandCreate()) {
    const tenantId: string = getDirectLandingUrlParams(directLandingUrlParams.tenantId);
    return tenantId === UATConstants.AllTenant['Red Button'].ID;
  }

  return false;
};

export const removeDirectLandingUrlQueryParams = (): void => {
  const url = new URL(window.location.href);
  const tenantId = url.searchParams.get(directLandingUrlParams.tenantId);
  if (tenantId) {
    const newUrl = `/hub?${directLandingUrlParams.tenantId}=${tenantId}`;
    window.history.pushState({}, document.title, newUrl);
    window.dispatchEvent(new Event(DIRECT_LANDING_CLOSED_EVENT));
  }
};

export const redirectToDashboardFromDirectLanding = (): void => {
  window.location.href = '/dashboard';
};

export const isDirectLandEcif = (): boolean => {
  const url = new URL(window.location.href);
  const region: string = url?.searchParams.get(directLandingUrlParams.region) || '';
  if (isDirectLandCreate()) {
    const tenantId: string = getDirectLandingUrlParams(directLandingUrlParams.tenantId);
    if (
      tenantId === UATConstants.AllTenant.ECIF.ID &&
      UATConstants.ECIFRegion.includes(region.toLocaleLowerCase())
    )
      return true;
    else return false;
  }

  return false;
};
export const isDirectLandUSMaas = (): boolean => {
  const url = new URL(window.location.href);
  const region: string = url?.searchParams.get(directLandingUrlParams.region) || '';
  if (isDirectLandCreate()) {
    const tenantId: string = getDirectLandingUrlParams(directLandingUrlParams.tenantId);
    if (tenantId === UATConstants.AllTenant.USMaaS.ID) return true;
    else return false;
  }

  return false;
};

export const isDirectLandCompete = (): boolean => {
  if (isDirectLandCreate()) {
    const tenantId: string = getDirectLandingUrlParams(directLandingUrlParams.tenantId);
    return tenantId === UATConstants.AllTenant.Compete.ID;
  }

  return false;
};

export const getSourceParam = (): string => {
  return getDirectLandingUrlParams(directLandingUrlParams.source);
};

export const isSourceMCAPSHelp = (): boolean => {
  const source = getSourceParam();
  return source && source.toLowerCase() === 'mcapshelp';
};

export const isHeaderless = (): boolean => {
  const isHeaderless = getDirectLandingUrlParams(directLandingUrlParams.headerless).toLowerCase() === 'true';
  const isDirectURL = window.location.pathname.toLowerCase().includes(UATConstants.Routes.CreateActionPageForField)
  return (isHeaderless && isDirectURL);
};
